<div [ngStyle]="getSkeletonStyles()" class="skeleton-load loader"></div>
